import { useLanguage } from '../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const RIVER_CRUISE_IMG = "https://customer-assets.emergentagent.com/job_dumitru-transport/artifacts/ioxoin1d_84f5255b-84af-48db-a5c3-af34efcc15b6.jpeg";
const ALPS_IMG = "https://customer-assets.emergentagent.com/job_dumitru-transport/artifacts/vqrulxjg_016e6b1b-dfda-4cfe-addd-888f49d89c78.jpeg";

const ServiceCards = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const cards = [
    {
      image: RIVER_CRUISE_IMG,
      title: t('service_card_cruise_title') || 'RIVER CRUISE TRANSFERS',
      description: t('service_card_cruise_desc') || 'Skip the hassle of trains and taxis. Enjoy a seamless journey from Zurich Airport directly to your river cruise ship near Basel.',
      bullets: [
        t('service_card_cruise_b1') || 'Daily transfers from Zurich',
        t('service_card_cruise_b2') || '5-7 passengers \u2013 premium vehicles',
        t('service_card_cruise_b3') || 'Direct transfers to your ship or hotel',
      ],
      testId: 'service-card-cruise',
    },
    {
      image: ALPS_IMG,
      title: t('service_card_alps_title') || 'Travel to the Alps \u2014 any time of the year.',
      description: t('service_card_alps_desc') || 'Enjoy a private, door-to-door journey from Zurich to the most popular ski resorts and destinations in Switzerland and Austria \u2013 available daily, in winter and throughout the entire year.',
      bullets: [
        t('service_card_alps_b1') || 'Daily transfers, all year round',
        t('service_card_alps_b2') || 'Premium vehicles (up to 7 passengers)',
        t('service_card_alps_b3') || 'Professional, English-speaking drivers',
      ],
      testId: 'service-card-alps',
    },
  ];

  return (
    <section className="py-20 px-4 bg-[#0A0A0A]" data-testid="service-cards-section">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {cards.map((card) => (
            <div
              key={card.testId}
              className="border border-[#D4AF37]/40 bg-[#0F0F0F] flex flex-col group hover:border-[#D4AF37]/70 transition-colors duration-300"
              data-testid={card.testId}
            >
              {/* Image */}
              <div className="w-full h-72 sm:h-80 overflow-hidden bg-[#0A0A0A]">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>

              {/* Content */}
              <div className="flex-1 p-8 flex flex-col bg-gradient-to-b from-[#151515] to-[#0A0A0A]">
                <h3
                  className="text-xl sm:text-2xl text-white mb-4 leading-tight"
                  style={{ fontFamily: 'Cormorant Garamond, serif' }}
                >
                  {card.title}
                </h3>

                {/* Gold separator */}
                <div className="w-16 h-[1px] bg-[#D4AF37] mb-5" />

                <p className="text-[#A1A1AA] text-sm leading-relaxed mb-6">
                  {card.description}
                </p>

                <ul className="space-y-2 mb-8">
                  {card.bullets.map((bullet, i) => (
                    <li key={i} className="flex items-start gap-2 text-[#E5E5E5] text-sm">
                      <span className="text-[#D4AF37] mt-0.5">&bull;</span>
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>

                {/* Book Now Button */}
                <button
                  onClick={() => navigate('/booking')}
                  className="mt-auto w-full flex items-center justify-between border border-[#D4AF37] text-[#D4AF37] px-6 py-4 font-medium tracking-wider uppercase hover:bg-[#D4AF37] hover:text-black transition-colors"
                  data-testid={`${card.testId}-book`}
                >
                  <span>{t('nav_booking')}</span>
                  <ArrowRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceCards;
